<ion-item class="service-item" (click)="onServiceDefinitionSelect()" lines="none">
  {{ serviceDefinition.name }} <ion-note class="service-note" slot="end">{{ serviceDefinition.price | salonMonsterCurrency }}</ion-note>
</ion-item>